import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { TodoState } from './todo.models';

export const selectTodoState = createFeatureSelector<TodoState>('todo');

export const selectTodoItems = createSelector(selectTodoState, (state) => state.items);
export const selectTodoLoading = createSelector(selectTodoState, (state) => state.loading);
export const selectTodoSaving = createSelector(selectTodoState, (state) => state.saving);
export const selectTodoError = createSelector(selectTodoState, (state) => state.error);
export const selectTodoMessage = createSelector(selectTodoState, (state) => state.message);
export const selectTodoSuccess = createSelector(selectTodoState, (state) => state.success);
